import { Component, Vue } from 'nuxt-property-decorator'

export interface LoggerInterface {
  debug(...message: any[]): void
  info(...message: any[]): void
}

@Component
class Logger extends Vue implements LoggerInterface {
  private _logTitle(): string {
    return `[${this.constructor.name}]`
  }

  public debug(...message: any[]) {
    this.$logger.debug(this._logTitle(), ...message)
  }

  public info(...message: any[]) {
    this.$logger.info(this._logTitle(), ...message)
  }
}

export { Logger }
export default Logger
